<template>
	<div class="pe">
		<nav v-if="access && access.admin" class="pe-fin-nav" aria-label="Pricing">
			<span class="pe-fin-grp">Sales</span>
			<router-link v-for="l in links.sales" :key="l.to" :to="l.to" class="vtab" :class="{ active: on(l) }" active-class="pe-nav-on" exact-active-class="pe-nav-on">{{ l.label }}</router-link>
			<span class="vsep"></span>
			<span class="pe-fin-grp">Finance</span>
			<router-link v-for="l in links.finance" :key="l.to" :to="l.to" class="vtab" :class="{ active: on(l) }" active-class="pe-nav-on" exact-active-class="pe-nav-on">{{ l.label }}</router-link>
		</nav>
		<div v-if="access && !access.admin && $route.path.startsWith('/pricing/admin')" class="qblock" style="margin-top:0">
			<h5>Finance decides this</h5>
			<p class="hint" style="margin:6px 0 0">These screens are for the people assigned as finance. Ask a finance person to assign you on People. <router-link to="/pricing">Back to quotes</router-link></p>
		</div>
		<template v-else>
			<pe-notice v-if="notice" :tone="notice.tone" :text="notice.text" @close="notice = null" />
			<router-view></router-view>
		</template>
		<pe-prompt ref="prompt" />
	</div>
</template>

<script>
// Pricing Engine v2 wrapper: the Accounts (Beta) tokens and classes from components/pe/pe.css,
// no module header bar and no active-account bar (the account context lives in each page).
// Who sees the finance screens comes from the API (/pricing/people, "me"): the finance people assigned in the app,
// or the Admin role while nobody is assigned. Own active classes: the app's global router-link rule paints a link solid blue.
import restApi from '../../api/index.js'
import { PeNotice, PePrompt } from '../../components/pe'

const LINKS = {
	sales: [{ to: '/pricing', label: 'New quote', exact: true }, { to: '/pricing/mine', label: 'My quotes' }],
	finance: [
		{ to: '/pricing/admin', label: 'To do', exact: true }, { to: '/pricing/admin/quotes', label: 'Quotes' },
		{ to: '/pricing/admin/floors', label: 'Floors and limits' }, { to: '/pricing/admin/bundles', label: 'Bundle values' },
		{ to: '/pricing/admin/catalog', label: 'Price list' }, { to: '/pricing/admin/rules', label: 'Rules' },
		{ to: '/pricing/admin/people', label: 'People' }, { to: '/pricing/admin/reports', label: 'Reports' },
	],
}

export default {
	name: 'PricingParent',
	components: { PeNotice, PePrompt },
	data: () => ({ links: LINKS, access: null, notice: null }),
	created() {
		this.loadAccess()
		this.$root.$on('pe-access-changed', this.loadAccess)
		// every pricing page reports through these two: a notice that stays, and a prompt modal that waits
		this.$root.$on('pe-notice', this.showNotice)
		this.$root.$pePrompt = opts => this.$refs.prompt.open(opts)
	},
	beforeDestroy() { this.$root.$off('pe-access-changed', this.loadAccess); this.$root.$off('pe-notice', this.showNotice); this.$root.$pePrompt = null },
	watch: { '$route.path'() { this.notice = null } },
	methods: {
		showNotice(n) { this.notice = n },
		loadAccess() { restApi.get('/pricing/people').then(({ data }) => { this.access = data.me }).catch(() => { this.access = { admin: false, sales: false } }) },
		on(l) { const p = this.$route.path.replace(/\/$/, '') || '/'; return l.exact ? p === l.to : p.startsWith(l.to) },
	},
}
</script>

<style src="../../components/pe/pe.css"></style>
